import React from 'react'
import Button from 'transfix-ui/components/Button'
import { Card, makeStyles, Typography } from 'transfix-ui/core'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { brandColors } from 'transfix-ui'

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(1),
  },
  title: {
    color: brandColors.coolGray5,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  iconContainer: {
    display: 'flex',
    backgroundColor: brandColors.skyBlue1,
    marginRight: theme.spacing(1),
    borderRadius: 5,
  },
  card: {
    padding: theme.spacing(1.5),
  },
  addTriggerButton: {
    marginTop: theme.spacing(1),
    display: 'flex',
    justifyContent: 'space-between',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
}))

interface ITriggerCardProps {
  children: React.ReactNode
  icon: React.ReactNode
  isAddTriggerDisabled: boolean
  onAddTrigger: () => void
  onCancel: () => void
  onRemove: () => void
  showClearButton: boolean
  title: string
}

const TriggerCard = ({
  children,
  icon,
  isAddTriggerDisabled,
  onAddTrigger,
  onCancel,
  onRemove,
  showClearButton,
  title,
}: ITriggerCardProps) => {
  const classes = useStyles()
  const isMpShipmentIssueAutomationM2Enabled = useFeatureFlag('mpShipmentIssueAutomationM2')

  return (
    <div className={classes.container}>
      <Card className={classes.card}>
        <div className={classes.header}>
          <div className={classes.titleContainer}>
            <div className={classes.iconContainer}>{icon}</div>
            <Typography variant='overline' className={classes.title}>
              {title}
            </Typography>
          </div>
          {isMpShipmentIssueAutomationM2Enabled && (
            <div>
              <Button color='tertiary' onClick={onRemove}>
                Remove
              </Button>
            </div>
          )}
        </div>
        {children}
      </Card>
      {isMpShipmentIssueAutomationM2Enabled && (
        <div className={classes.addTriggerButton}>
          <Button color='primary' onClick={onAddTrigger} disabled={isAddTriggerDisabled}>
            And
          </Button>
          {showClearButton && (
            <Button color='tertiary' onClick={onCancel}>
              Cancel
            </Button>
          )}
        </div>
      )}
    </div>
  )
}

export default TriggerCard
